// extracted by mini-css-extract-plugin
module.exports = {"siteContainer":"layout-module--siteContainer--16IDw","siteMain":"layout-module--siteMain--1ad9e"};